<template>
  <div class="parking-register" :class="{'app-region blank-t-v blank-b-v blank-l-h blank-r-h': !isChangeLicense && !isContinueLease}" v-if="!isScan">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" v-if="!isChangeLicense && !isContinueLease">
      <a-form-model-item label="车位信息">{{info.name}}</a-form-model-item>
      <a-form-model-item label="租售方式" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">{{parkingStatusText(1)}}</a-radio>
          <a-radio :value="2">{{parkingStatusText(2)}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="所属房屋" prop="house">
        <div>
          <a-button type="primary" @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large" closable @close.prevent="delHouse(index)" v-for="(value, index) in form.house" :key="index">{{value.full_name}}</a-tag>
        </div>
      </a-form-model-item>
      <a-form-model-item label="住户姓名" prop="resident">
        <a-select v-model="form.resident" placeholder="请选择住户姓名">
          <a-select-option :value="value.id" v-for="(value, index) in residentOptions" :key="index">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="车辆车牌" prop="carNumber">
        <a-input-group compact>
          <a-select v-model="form.cityName">
            <a-select-option :value="value" v-for="(value, index) in cityName" :key="index">{{value}}</a-select-option>
          </a-select>
          <a-input v-model="form.carNumber" placeholder="请输入车辆车牌" allow-clear></a-input>
        </a-input-group>
      </a-form-model-item>
      <template v-if="form.type === 1">
        <a-form-model-item label="出售日期" prop="time">
          <a-date-picker v-model="form.time" placeholder="请选择出售日期" valueFormat="YYYY-MM-DD"></a-date-picker>
        </a-form-model-item>
      </template>
      <template v-if="form.type === 2">
        <a-form-model-item label="出租日期" prop="time">
          <a-date-picker v-model="form.time" placeholder="请选择出租日期" valueFormat="YYYY-MM-DD"></a-date-picker>
        </a-form-model-item>
        <a-form-model-item label="出租时长" prop="duration">
          <a-input type="number" :min="1" v-model="form.duration" placeholder="请输入出租时长">
            <p slot="addonAfter">月</p>
          </a-input>
        </a-form-model-item>
      </template>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <!-- 变更车牌 续租 -->
    <a-form-model ref="form" :model="form" layout="vertical" :rules="rules" v-else>
      <a-form-model-item label="车辆车牌" prop="carNumber" v-if="isChangeLicense">
        <a-input-group compact>
          <a-select v-model="form.cityName">
            <a-select-option :value="value" v-for="(value, index) in cityName" :key="index">{{value}}</a-select-option>
          </a-select>
          <a-input v-model="form.carNumber" placeholder="请输入车辆车牌" allow-clear></a-input>
        </a-input-group>
      </a-form-model-item>
      <a-form-model-item label="出租时长" prop="duration" v-if="isContinueLease">
        <a-input type="number" :min="1" v-model="form.duration" placeholder="请输入出租时长">
          <p slot="addonAfter">月</p>
        </a-input>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.house" :data="tree.data" :params="tree.params" :load-data="$houseTreeData" @load="loadTreeSelectNode"></tree-select>
    </a-modal>
  </div>
  <div class="resident-info" v-else>
    <a-descriptions bordered v-viewer>
      <a-descriptions-item label="车位信息">{{info.name}}</a-descriptions-item>
      <a-descriptions-item label="租售方式">{{parkingStatusText(info.sale_state)}}</a-descriptions-item>
      <a-descriptions-item label="所属房屋">{{info.carport_housing.housing.full_name}}</a-descriptions-item>
      <a-descriptions-item label="住户姓名">{{info.owner.name}}</a-descriptions-item>
      <a-descriptions-item label="车辆车牌">{{info.car_number.join('、')}}</a-descriptions-item>
      <template v-if="info.sale_state === 1">
        <a-descriptions-item label="出售日期">{{info.carport_housing.period_start}}</a-descriptions-item>
      </template>
      <template v-else>
        <a-descriptions-item label="出租日期">{{info.carport_housing.period_start}}</a-descriptions-item>
        <a-descriptions-item label="出租时长">{{info.month_num}}月</a-descriptions-item>
      </template>
    </a-descriptions>
  </div>
</template>

<script>
  import {
    cityName,
    parkingStatusText
  } from '@/io/dict.js';
  import r from '@/assets/js/rule.js';
  import ResidentService from '@/io/resident.js';
  import ParkingService from '@/io/parking.js';

  export default {
    name: 'ParkingRegister',
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      isChangeLicense: {
        type: Boolean,
        default: false
      },
      isContinueLease: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      }
    },
    data() {
      return {
        cityName,
        parkingStatusText,
        parkingId: this.$route.query.id,
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        modal: {
          title: '选择房屋',
          show: false,
          house: []
        },
        form: {
          type: null,
          house: [],
          resident: [],
          cityName: cityName[0],
          carNumber: null,
          time: null,
          duration: null
        },
        rules: {
          type: [
            {
              required: true,
              message: '请选择租售方式'
            }
          ],
          house: [
            {
              required: true,
              message: '请选择所属房屋'
            }
          ],
          resident: [
            {
              required: true,
              message: '请选择住户姓名'
            }
          ],
          carNumber: [
            {
              required: true,
              message: '请填写车辆车牌'
            },
            {
              validator: this.$debounce((rule, value, callback) => {
                if (value && !r.rule2(`${this.form.cityName}${value}`)) {
                  callback(new Error('请输入正确车辆车牌'));
                } else {
                  callback();
                }
              })
            }
          ],
          time: [
            {
              required: true,
              message: '请选择日期'
            }
          ],
          duration: [
            {
              required: true,
              message: '请填写出租时长'
            }
          ]
        },
        residentOptions: [],
        info: {
          car_number: [],
          carport_housing: {
            housing: {}
          },
          owner: {}
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initTreeData().then(() => {
            if (newValue) {
              this.initPage();
            }
          });
        },
        immediate: true
      },
      'form.house': {
        handler(newValue, oldValue) {
          this.form.resident = [];
          if (newValue.length) {
            ResidentService.listPage(null, newValue[0].id).then(res => {
              this.residentOptions = res;
            }).catch(err => {});
          }
        },
        immediate: true
      }
    },
    methods: {
      loadTreeSelectNode(data) {
        data.children.forEach(val => {
          this.$set(val, 'disabled', val.level <= 3);
        });
      },
      initTreeData() {
        return this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 4]).then(res => {
          this.tree.data = res.map(val => {
            val.disabled = true;
            return val;
          })
        });
      },
      confirmModal() {
        this.modal.show = false;
        this.form.house = this.$createNewVariable(this.modal.house);
      },
      showModal() {
        this.modal.show = true;
        this.modal.house = this.$createNewVariable(this.form.house);
      },
      delHouse(index) {
        this.form.house.splice(index, 1);
      },
      initPage() {
        if (this.id) {
          ParkingService.info(this.id).then(res => {
            this.info = res;
          }).catch(err => {});
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.isChangeLicense) {
            ParkingService.changeNumber(
              this.id,
              [`${this.form.cityName}${this.form.carNumber}`]
            ).then(res => {
              this.$afterFormSubmit('变更车牌成功', () => {
                this.$emit('confirm');
              });
            }).catch(err => {});
          } else if (this.isContinueLease) {
            ParkingService.continueDate(
              this.id,
              this.form.duration
            ).then(res => {
              this.$afterFormSubmit('续租成功', () => {
                this.$emit('confirm');
              });
            }).catch(err => {});
          } else {
            ParkingService.register(
              this.id,
              this.info.name,
              this.form.type,
              this.form.house[0].id,
              this.form.resident,
              [`${this.form.cityName}${this.form.carNumber}`],
              this.form.time,
              this.form.duration || 0
            ).then(res => {
            this.$afterFormSubmit('登记成功', () => {
              this.cancel();
            });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          name: 'ParkingManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  .ant-input-group-compact {
    .ant-select {
      width: 60px;
    }
    .ant-input-affix-wrapper {
      width: calc(100% - 60px);
    }
  }
</style>